import React from 'react';
import { avatarColor, initials } from '../../design/format';
import { fmt } from '../../design/format';
import { useAgentPhoto } from '../../services/agentPhotos';

export function Avatar({ name, large = false, photoId }) {
  const photo = useAgentPhoto(photoId);
  return (
    <span className={`avatar${large ? ' lg' : ''}`} style={{ background: avatarColor(name) }} aria-hidden="true">
      {photo ? <img className="avatar-photo" src={photo} alt="" /> : initials(name)}
    </span>
  );
}

// Signature motif: docs/design/mockups/_build/shell-data.js D.routeStrip.
export const ROUTE_LABEL = {
  aa: 'Auto attendant',
  queue: 'Queue',
  agent: 'Agent',
  transfer: 'Transfer',
  forward: 'Forward',
  voicemail: 'Voicemail',
  abandon: 'Abandoned',
  external: 'External number',
};

export function RouteStrip({ steps }) {
  const label = `Route: ${steps.map((s) => s.name).join(', then ')}`;
  return (
    <span className="route" aria-label={label}>
      {steps.map((step, i) => (
        <React.Fragment key={`${step.type}-${i}`}>
          {i > 0 && <span className="seg-link" />}
          <span
            className={`seg-node route-${step.type}`}
            title={`${ROUTE_LABEL[step.type] || step.type}: ${step.name}${step.seconds ? ` (${fmt.mmss(step.seconds)})` : ''}`}
          />
        </React.Fragment>
      ))}
    </span>
  );
}
